<div class="mailbox">
  <mat-card appearance="outlined" class="service-toggle-card">
    @if (noService()) {
      <div class="header row">
        <div>
          <h2>Mail Service</h2>
          <span>
            This website does not have mail service in VMAX yet. To get started, add mail service
            for {{ website().domain }}.
          </span>
        </div>

        <button matButton="filled" (click)="addMailboxService()" [disabled]="creatingService()">
          <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
          Add Mail Service
        </button>
      </div>
    } @else {
      <div class="header row">
        <div class="space row">
          <mat-slide-toggle
            [checked]="serviceEnabled()"
            (change)="onServiceToggleChange($event)"
            [disabled]="loadingService()"
          ></mat-slide-toggle>
          <div>
            <h2>Mail Service is {{ serviceEnabled() ? 'enabled' : 'disabled' }}</h2>
            <span>
              {{
                serviceEnabled()
                  ? 'Required DNS records, virus and spam filtering are configured automatically.'
                  : 'Enable it to configure the required DNS records, activate virus and spam filtering, and start using email with this domain.'
              }}
            </span>
          </div>
        </div>
        <button
          matRipple
          class="icon-button outlined destructive"
          [matTooltip]="
            (mailboxUsers$ | async)?.length
              ? 'The Mail Service can be deleted only if no mailboxes have been added. To enable the Delete option, remove all mailboxes first.'
              : 'Delete Mail Service'
          "
          [matTooltipShowDelay]="500"
          (click)="deleteMailboxService()"
          [disabled]="loadingService() || (mailboxUsers$ | async)?.length"
        >
          <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
        </button>
      </div>
    }
  </mat-card>

  @if (mailboxUsers$ | async; as records) {
    @if (!noService()) {
      <app-search-field
        placeholder="Search Mailbox"
        id="record-search"
        (searchText)="onSearch($event)"
      ></app-search-field>

      <div class="table-container">
        <div class="header row">
          <h2>Mailboxes</h2>
          <div class="buttons row">
            <button matButton="filled" (click)="addMailbox()" [disabled]="!serviceEnabled()">
              <img class="custom-icon" src="assets/icons/custom-mail-plus.svg" alt="Mail-plus" />
              Add Mailbox
            </button>
            <button matButton="outlined" (click)="goToWebMail()" [disabled]="!serviceEnabled()">
              <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="lg"></fa-icon>
              Webmail
            </button>
            <button
              matButton="outlined"
              class="app-btn-destructive"
              [disabled]="!serviceEnabled() || !records.length"
            >
              <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
              Delete All Mailboxes
            </button>
          </div>
        </div>

        <mat-card appearance="outlined" class="mailboxes">
          <app-table
            #table
            [columns]="mailboxesColumns"
            [dataSource]="records"
            [totalCount]="records.length || 0"
            (pageChange)="handlePageEvent($event)"
          >
            <ng-container matColumnDef="mailbox">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Mailbox</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle
                  [checked]="element.status !== 'DISABLED'"
                  (change)="onUserToggleChange($event, element.id)"
                ></mat-slide-toggle>
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <app-status-label [status]="toStatus(element.status)"></app-status-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="button"
                    matTooltip="Login to Webmail"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                  >
                    <fa-icon [icon]="['fas', 'arrow-right-to-bracket']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="button"
                    matTooltip="Mailbox Settings"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="editMailbox(element)"
                  >
                    <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
                  </button>
                  <button
                    matRipple
                    class="button"
                    matTooltip="Delete Mailbox"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteMailbox(element)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>
          </app-table>
        </mat-card>
      </div>
    }
  }
</div>
